import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Img } from '../../ui-kit/Img/Img.js';
import { RichText } from '../../ui-kit/RichText/RichText.js';
import { adjustHref } from '../../utils/adjustHref.js';
import { formatBytes } from '../../utils/formatBytes.js';
import { LinkDocItem } from './LinkDocItem.js';
import { linkIconStyle } from './linkIconStyle.js';
export const renderDefaultItem = (router, icon) => (docBlockDef, i) => {
    const href = adjustHref(router)(docBlockDef?.docType === 'Attachment' ? docBlockDef?.attachment?.src : docBlockDef?.href);
    const fileSize = docBlockDef?.docType === 'Attachment'
        ? formatBytes(docBlockDef?.attachment?.fileSize || 0)
        : docBlockDef?.fileSize;
    const fileFormat = docBlockDef?.docType === 'Attachment' ? getExtFromHref(href) : docBlockDef?.fileFormat;
    return (_jsxs("div", { role: "listitem", children: [_jsx(LinkDocItem, { text: docBlockDef?.text, target: docBlockDef?.target, href: href, fileFormat: fileFormat, fileSize: fileSize, icon: renderImg(icon), data: docBlockDef?.data }), _jsx(RichText, { __html: docBlockDef?.__html })] }, String(i)));
};
const renderImg = (icon) => icon ? _jsx(Img, { className: linkIconStyle, image: icon, width: "24", height: "24" }) : null;
const getExtFromHref = (href) => {
    if (!href) {
        return '';
    }
    const index = href.lastIndexOf('.');
    const regexp = new RegExp(/\/(.*)/);
    const docFormat = index !== -1 ? href.substring(index + 1) : '';
    return docFormat.includes('/') ? docFormat.replace(regexp, '') : docFormat;
};
//# sourceMappingURL=renderDefaultItem.js.map